import EffortlyLogo from '../images/effortly-logo.svg';
import Dashboard from '../images/effortly-dashboard.svg';
import Live from '../images/effortly-liveview.svg';
import Insight from '../images/effortly-insight.svg';
import Map from '../images/effortly-mapview.svg';
import Reports from '../images/effortly-reports.svg';
import Settings from '../images/effortly-settings.svg';
import './Effortly.css';

function Effortly() {
    return(
        <>
            <section class="effortly-section" id="products">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 wow zoomIn">
                            <div class="effortly-content">
                                <h2>Amplify your team's potential</h2>
                                <p>Unlock untapped potential with our software: streamline workflows, track time, and analyze
                                    productivity
                                    for optimal team performance</p>
                            </div>
                        </div>
                        <div class="col-lg-4 wow flipInX">
                            <div class="effortly-content-logo">
                                <img class="img-fluid" src={EffortlyLogo} alt="effortly-logo" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-md-6 col-lg-4">
                            <div class="effortly-card">
                                <img class="img-fluid" src={Dashboard} alt="" />
                                <div class="effortly-card-content">
                                    <h3>Dashboard</h3>
                                    <p>Monitor key performance metrics such as productive hours, application usage and work
                                        hours insight.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="effortly-card">
                                <img class="img-fluid" src={Live} alt="" />
                                <div class="effortly-card-content">
                                    <h3>Live View</h3>
                                    <p>Observe employee activity and engagement in real-time to ensure optimal performance and
                                        workflow.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="effortly-card">
                                <img class="img-fluid" src={Insight} alt="" />
                                <div class="effortly-card-content">
                                    <h3>Insight</h3>
                                    <p>Utilize comprehensive data analytics to evaluate employee performance and efficiency.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="effortly-card">
                                <img class="img-fluid" src={Map} alt="" />
                                <div class="effortly-card-content">
                                    <h3>Map</h3>
                                    <p>Monitor the real-time location of your employees to ensure accountability and optimize
                                        field
                                        operations.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="effortly-card">
                                <img class="img-fluid" src={Reports} alt="" />
                                <div class="effortly-card-content">
                                    <h3>Reports</h3>
                                    <p>Detailed analysis of employee’s productive and unproductive work hours for
                                        accountability.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="effortly-card">
                                <img class="img-fluid" src={Settings} alt="" />
                                <div class="effortly-card-content">
                                    <h3>Settings</h3>
                                    <p>Define clear guidelines and standards within the software to monitor and enhance employee
                                        performance
                                        effectively.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
export default Effortly;